if (!customElements.get("image-with-text-slider")) {
  
  // Helper function to query DOM nodes
  function queryDomNodes(selectors, context) {
    const nodes = {}
    for (const [key, selector] of Object.entries(selectors)) {
      const elements = context.querySelectorAll(selector)
      nodes[key] = elements.length > 1 ? Array.from(elements) : elements[0]
    }
    return nodes
  }
  
  // Default settings if FoxThemeSettings is not available
  if (typeof FoxThemeSettings === 'undefined') {
    window.FoxThemeSettings = {
      isMobile: window.innerWidth < 768
    }
  }
  
  // Default settings if FoxThemeSettings is not available
  if (typeof FoxThemeSettings === 'undefined') {
    window.FoxThemeSettings = {
      isMobile: window.innerWidth < 768
    }
  }
  
  class imageWithTextSlider extends HTMLElement {
    constructor() {
      super()
      this.selectors = {
        tabs: '.hero-banner-slider__tab',
        images: '.hero-banner-slider__image',
        mediaContainer: '.hero-banner-slider__images',
        leftContainer: '.hero-banner-slider__left',
        rightContainer: '.hero-banner-slider__right'
      }
      this.domNodes = queryDomNodes(this.selectors, this)
      this.currentIndex = 0
      this.isHovering = false
      this.hoverTimeout = null
      this.init()
    }

    disconnectedCallback() {
      clearInterval(this.check)
      if (this.hoverTimeout) {
        clearTimeout(this.hoverTimeout)
      }
      this.removeEventListeners()
    }

    init() {
      this.check = setInterval(() => {
        this.mediaSlider = this.domNodes.mediaContainer.slider && this.domNodes.mediaContainer.slider.instance
        if (this.mediaSlider && typeof this.mediaSlider == 'object') {
          clearInterval(this.check)
          this.removeAttribute('data-media-loading')
          this.setupEventListeners()
          this.mediaSlider.on('change', this.handleMediaChange.bind(this))
          this.handleScreenChange()
          this.playVideo()
          // 设置第一个标签为默认激活状态
          this.setDefaultActiveTab()
        }
      }, 100)
    }

    setDefaultActiveTab() {
      if (this.domNodes.tabs.length > 0) {
        this.domNodes.tabs[0].classList.add('hero-banner-slider__tab--active')
      }
    }

    setupEventListeners() {
      // Tab click events
      this.domNodes.tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => {
          this.switchToSlide(index)
        })

        // Hover events for desktop
        if (!FoxThemeSettings.isMobile) {
          tab.addEventListener('mouseenter', () => {
            this.isHovering = true
            if (this.hoverTimeout) {
              clearTimeout(this.hoverTimeout)
            }
            this.hoverTimeout = setTimeout(() => {
              if (this.isHovering) {
                this.switchToSlide(index)
              }
            }, 100)
          })

          tab.addEventListener('mouseleave', () => {
            this.isHovering = false
            if (this.hoverTimeout) {
              clearTimeout(this.hoverTimeout)
            }
            // 鼠标离开标签区域时，不重置选中状态，保持最后一个悬停选中状态
          })
        }
      })

      // Touch events for mobile
      if (FoxThemeSettings.isMobile) {
        this.domNodes.mediaContainer.addEventListener('touchstart', this.handleTouchStart.bind(this))
        this.domNodes.mediaContainer.addEventListener('touchmove', this.handleTouchMove.bind(this))
      }

      // Keyboard navigation
      document.addEventListener('keydown', this.handleKeydown.bind(this))
    }

    removeEventListeners() {
      // 简化事件移除，主要移除键盘事件
      document.removeEventListener('keydown', this.handleKeydown)
    }

    switchToSlide(index) {
      if (index === this.currentIndex) return

      // Update tabs
      this.domNodes.tabs.forEach((tab, i) => {
        if (i === index) {
          tab.classList.add('hero-banner-slider__tab--active')
        } else {
          tab.classList.remove('hero-banner-slider__tab--active')
        }
      })

      // Update media slider
      if (this.mediaSlider) {
        this.mediaSlider.select(index)
      }

      this.currentIndex = index
      this.playVideo()
    }

    handleMediaChange(index) {
      this.switchToSlide(index)
    }

    handleTouchStart(e) {
      this.touchStartX = e.touches[0].clientX
      this.touchStartY = e.touches[0].clientY
    }

    handleTouchMove(e) {
      if (!this.touchStartX || !this.touchStartY) return

      const touchX = e.touches[0].clientX
      const touchY = e.touches[0].clientY
      const diffX = this.touchStartX - touchX
      const diffY = this.touchStartY - touchY

      // Only handle horizontal swipes
      if (Math.abs(diffX) > Math.abs(diffY)) {
        if (diffX > 50) {
          // Swipe left - next slide
          this.nextSlide()
          this.touchStartX = null
          this.touchStartY = null
        } else if (diffX < -50) {
          // Swipe right - previous slide
          this.previousSlide()
          this.touchStartX = null
          this.touchStartY = null
        }
      }
    }

    handleKeydown(e) {
      switch(e.key) {
        case 'ArrowLeft':
          e.preventDefault()
          this.previousSlide()
          break
        case 'ArrowRight':
          e.preventDefault()
          this.nextSlide()
          break
        case 'Home':
          e.preventDefault()
          this.switchToSlide(0)
          break
        case 'End':
          e.preventDefault()
          this.switchToSlide(this.domNodes.tabs.length - 1)
          break
        default:
          // Number keys 1-9
          if (e.key >= '1' && e.key <= '9') {
            const index = parseInt(e.key) - 1
            if (index < this.domNodes.tabs.length) {
              e.preventDefault()
              this.switchToSlide(index)
            }
          }
      }
    }

    nextSlide() {
      const nextIndex = (this.currentIndex + 1) % this.domNodes.tabs.length
      this.switchToSlide(nextIndex)
    }

    previousSlide() {
      const prevIndex = (this.currentIndex - 1 + this.domNodes.tabs.length) % this.domNodes.tabs.length
      this.switchToSlide(prevIndex)
    }

    playVideo() {
      this.pauseAllMedia()
      const selectedElm = this.mediaSlider ? this.mediaSlider.selectedElement : null
      if (!selectedElm) return

      const deferredMedia = selectedElm.querySelector('deferred-media')
      if (deferredMedia) {
        deferredMedia.loadContent()
        const youtube = deferredMedia.querySelector('.js-youtube')
        const vimeo = deferredMedia.querySelector('.js-vimeo')
        const video = deferredMedia.querySelector('video')
        if (video) video.play()
        if (youtube) youtube.contentWindow.postMessage('{"event":"command","func":"' + 'playVideo' + '","args":""}', '*')
        if (vimeo) vimeo.contentWindow.postMessage('{"method":"play"}', '*')
      }
    }

    pauseAllMedia() {
      this.querySelectorAll(".js-youtube").forEach((video) => {
        video.contentWindow.postMessage(
          '{"event":"command","func":"' + "pauseVideo" + '","args":""}',
          "*"
        );
      });
      this.querySelectorAll(".js-vimeo").forEach((video) => {
        video.contentWindow.postMessage('{"method":"pause"}', "*");
      });
      this.querySelectorAll("video").forEach((video) => video.pause());
    }

    handleScreenChange() {
      // Handle responsive behavior if needed
      if (FoxThemeSettings.isMobile) {
        // Mobile-specific adjustments
      }
      document.addEventListener('matchMobile', () => {
        // Mobile adjustments
      })
      document.addEventListener('unmatchMobile', () => {
        // Desktop adjustments
      })
    }
  }

  customElements.define('image-with-text-slider', imageWithTextSlider)
}